module.exports = __webpack_public_path__ + "img/main-header-image.8043f8c6.jpg";